import type { LevelDefinition } from './Level.ts';
import { level01 } from './level01.ts';
import { level02 } from './level02.ts';
import { level03 } from './level03.ts';
import { level04 } from './level04.ts';
import { level05 } from './level05.ts';
import { level06 } from './level06.ts';
import { level07 } from './level07.ts';
import { level08 } from './level08.ts';
import { level09 } from './level09.ts';

export const LEVELS: LevelDefinition[] = [
  level01,
  level02,
  level03,
  level04,
  level05,
  level06,
  level07,
  level08,
  level09,
];

/** Pick a level by 1-based index, clamped. Used by the ?level= query flag. */
export function levelByIndex(index: number): LevelDefinition {
  const clamped = Math.min(Math.max(Math.floor(index), 1), LEVELS.length);
  return LEVELS[clamped - 1];
}
